<template>
  <div class="group rounded-lg bg-white shadow-[0_0_40px_0_rgba(170,182,211,0.10)] overflow-hidden flex flex-col transition cursor-pointer" @click="$emit('open-preview', product)">
    <div class="relative aspect-[4/3] bg-gray-100 overflow-hidden">
      <img
        :src="`${imagesBaseUrl}${product.image}`"
        :alt="product.name"
        class="h-full w-full object-cover group-hover:scale-105 transition duration-500"
      />
    </div>
    <div class="p-3 flex flex-col flex-1 gap-2">
      <h3 class="text-xs font-medium text-primary line-clamp-2 min-h-[1.5rem]">{{ product.name }}</h3>
      <p class="text-base font-bold text-primary mt-auto">{{ product.price_preview }} ₽</p>
    </div>
  </div>
</template>

<script>
import { API_CONFIG } from '@/config'

export default {
  name: 'ProductCard',
  components: { },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  emits: ['open-preview'],
  data() {
    return {
      imagesBaseUrl: API_CONFIG.staticBaseUrl
    }
  }
}
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-clamp: 2;
}
</style>